import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { ResetForgetPasswordPayloadType } from '../../../commonTypes/authTypes';
import { checkHasLowerLetter, checkHasNumber, checkHasSpecial, checkHasUpperLetter, convertPasswordToHash } from '../../../utils/commonFunctions';
import { ContentArea } from '../../commons'
import { HidePassword, ViewPassword } from '../../Icon'
import ImageSlider from '../../Login/LoginCard/ImageSlider';
import { LoginBgImg1, LoginBgImg2, checkedImage, hideEyeGray, unCheckedImage, viewEyeGray } from '../../../assets/images';
import "./ResetPassword.scss"
import PasswordValidationCard from '../../commons/PasswordValidationCard/PasswordValidationCard';

type PasswordType = {
    newPassword: string;
    confirmNewPassword: string;
}

type PasswordResult = {
    atLeast: boolean;
    upperCase: boolean;
    special: boolean;
    lowerCase: boolean;
    number:boolean;
}

type PasswordErrorType = {
    newPasswordError: string;
    confirmNewPasswordError: string;
}

type AppProps = {
    handleSubmitResetPassword: (data: any) => void;
}

const ResetForgetPasswordCard = ({
    handleSubmitResetPassword
}: AppProps) => {
    const [toggleNewPassword, setToggleNewPassword] = useState<boolean>(false);
    const handleToggleNewPassword = () => {
        setToggleNewPassword(!toggleNewPassword);
    }
    const [passwordData, setPasswordData] = useState<PasswordType>({
        newPassword: "",
        confirmNewPassword: ""
    });

    const [passwordError, setPasswordError] = useState<PasswordErrorType>({
        newPasswordError: "",
        confirmNewPasswordError: ""
    });
    const [passwordPopUpShow, serPasswordPopUpshow] = useState(false);
    const [toggleConfirmPassword, setToggleConfirmPassword] = useState<boolean>(false);
    const [errorText, setError] = useState('')
    const [passwordValidation, setPasswordValidation] = useState<PasswordResult>({
        atLeast: false,
        upperCase: false,
        special: false,
        lowerCase: false,
        number: false,
    });

    const handleToggleConfirmNewPassword = () => {
        setToggleConfirmPassword(!toggleConfirmPassword);
    }

    const popOver = (e: any) => {
        serPasswordPopUpshow(false);
    };

    const handleChangeNewPassword = (event: any) => {
        serPasswordPopUpshow(true);
        setPasswordData((prevState) => ({
            ...prevState,
            newPassword: event.target.value.trim(),

        }));
        setPasswordError((prev: any) => ({
            ...prev,
            confirmNewPasswordError: ""
        }));
        let specialCharacterValue = checkHasSpecial(event.target.value);
        let uppercaseLetterValue = checkHasUpperLetter(event.target.value);
        let lowercaseLetterValue = checkHasLowerLetter(event.target.value);
        let numbercaseLetterValue = checkHasNumber(event.target.value);

        setPasswordValidation((prev: PasswordResult) => ({
            ...prev,
            ...(!!specialCharacterValue && { special: true }),
            ...(!!uppercaseLetterValue && { upperCase: true }),
            ...(!!lowercaseLetterValue && { lowerCase: true }),
            ...(!!numbercaseLetterValue && { number: true }),
            ...(!!(event.target.value.length >= 8) && { atLeast: true }),
            ...(!specialCharacterValue && { special: false }),
            ...(!uppercaseLetterValue && { upperCase: false }),
            ...(!lowercaseLetterValue && { lowerCase: false }),
            ...(!numbercaseLetterValue && { number: false }),
            ...(!(event.target.value.length >= 8) && { atLeast: false }),
        }))
        if (!event.target.value.length) {
            setPasswordData((prevState) => ({
                ...prevState,
                confirmNewPassword: ""

            }));
        }

        if (passwordError.newPasswordError) {
            setPasswordError((prev: any) => ({
                ...prev,
                newPasswordError: ""
            }));
        }
    }

    const handleChangeConfirmPassword = (event: any) => {
        setPasswordData((prevState) => ({
            ...prevState,
            confirmNewPassword: event.target.value.trim()
        }));

        if (passwordError.confirmNewPasswordError) {
            setPasswordError((prev: any) => ({
                ...prev,
                confirmNewPasswordError: "",
            }));
        }
    }

    const handleSubmitData = () => {
        if (passwordData?.newPassword && passwordData?.confirmNewPassword) {
            validatePassword()
        }
        else {
            if (!passwordData?.newPassword || !passwordData?.confirmNewPassword) {
                setError(" ")
            }
            setPasswordError((prev: any) => ({
                ...prev,
                ...(!passwordData?.newPassword && {
                    newPasswordError: "Required"
                }),
                ...(!passwordData?.confirmNewPassword && {
                    confirmNewPasswordError: "Required"
                })
            }))
        }
    }

    const handlePasswordChange = async () => {
        setPasswordError((prev: any) => ({
            ...prev,
            ...(passwordData?.confirmNewPassword === passwordData?.newPassword && {
                confirmNewPasswordError: ""
            })
        }));
        let enNewPassword = await convertPasswordToHash(passwordData?.newPassword);
        let enConfirmPassword = await convertPasswordToHash(passwordData?.confirmNewPassword);

        let data = {
            newPassword: enNewPassword,
            confirmPassword: enConfirmPassword,
        }
        handleSubmitResetPassword?.(data)
    }

    const validatePassword = () => {
        if (passwordData?.confirmNewPassword !== passwordData?.newPassword) {
            setPasswordError((prev: any) => ({
                ...prev,
                confirmNewPasswordError: "Your both password should match!",
            }));
            return
        }
        else {
            setError('')
            handlePasswordChange()
        }
    }

    return (
        <>
            < div className='container-fluid'>
                <div className="row" style={{ height: '100vh' }}>
                    <div className="col-md-5 back-ground-img" style={{ backgroundColor: '#262a44' }}>
                        <img className='position-fixed top-0 start-0' style={{ height: '220px' }} src={LoginBgImg2} />
                        <img className='position-fixed top-0 start-0' src={LoginBgImg1} />
                        <div className="d-flex justify-content-center align-items-center">
                            <ImageSlider />
                        </div>
                        <div className='company-details'>
                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <span>Akssai ProjExel Pvt. Ltd.</span>
                                <span>26 Dixit Enclave, Gorakhpur, Narmada Road, Jabalpur, MP 482004</span>
                                <span>www.akssai.com | info@akssai.com | +91 7000209293</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7 d-flex justify-content-center align-items-center ml-0 login-right" >
                        <div className='w-50'>
                            <h5>Create New Password</h5>
                            <p style={{ color: "#5f6e7c" }}>To Reset your password. Enter your new password and confirm new password here.</p>
                            <div className="form-group">

                                <div className="password-position position-relative">
                                    <label htmlFor="formData"
                                    >Enter New Password</label>
                                    <input
                                        type={!toggleNewPassword ? "password" : "text"}
                                        className={`form-control ${!!passwordError?.newPasswordError ? "error-border" : null}`}
                                        value={passwordData?.newPassword}
                                        autoComplete="off"
                                        // onBlur={popOver}
                                        onChange={(e: any) => handleChangeNewPassword(e)}
                                    />
                                    {!!passwordError?.newPasswordError && <small className="text-danger">{passwordError?.newPasswordError}</small>}
                                    <div className="icon-box" onClick={handleToggleNewPassword}>
                                        {toggleNewPassword ? <img src={viewEyeGray} alt="eye" /> : <img src={hideEyeGray} alt="eye" />}
                                    </div>
                                    {passwordData?.newPassword?.length &&
                                        passwordPopUpShow &&
                                        Object.values(passwordValidation).includes(false) ? (
                                            <PasswordValidationCard
                                            className={"tool-text position-absolute"}
                                            triangleClassName={"trangle position-absolute"}
                                            isLeast={passwordValidation?.atLeast}
                                            isUpperCase={passwordValidation?.upperCase}
                                            isLowerCase={passwordValidation?.lowerCase}
                                            isSpecial={passwordValidation?.special}
                                            isNumber={passwordValidation?.number}
                                          />
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="password-position ">
                                    <label htmlFor="formData"
                                    >Confirm New Password</label>
                                    <input
                                        type={!toggleConfirmPassword ? "password" : "text"}
                                        className={`form-control ${!!passwordError?.confirmNewPasswordError ? "error-border" : null}`}
                                        value={passwordData?.confirmNewPassword}
                                        autoComplete="off"
                                        onChange={(e: any) => handleChangeConfirmPassword(e)}
                                        disabled={!passwordData?.newPassword}
                                    />
                                    {!!passwordError?.confirmNewPasswordError && <small style={{ color: "#e7733e", fontSize: "15px" }}>{passwordError?.confirmNewPasswordError}</small>}
                                    <div className="icon-box" onClick={handleToggleConfirmNewPassword}>
                                        {toggleConfirmPassword ? <img src={viewEyeGray} alt="eye" /> : <img src={hideEyeGray} alt="eye" />}
                                    </div>
                                </div>
                            </div>
                            <p className='error'>{errorText ? errorText : ''}</p>
                            <div className="mb-3 mt-3">
                                <button
                                    className="btn btn-primary w-100"
                                    onClick={handleSubmitData}
                                    disabled={!(passwordData?.newPassword?.length >= 8) || !passwordData?.confirmNewPassword || !passwordValidation?.special || !passwordValidation?.lowerCase || !passwordValidation?.upperCase||!passwordValidation?.number}
                                >
                                    Reset Password
                                </button>
                            </div>
                            <div className='text-center'>
                                <p style={{ marginBottom: '0rem' }}>Already have an account?</p>
                                <p><span>
                                    <Link to='/' style={{ color: '#dd4433' }}>Login</Link>
                                </span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default ResetForgetPasswordCard

